/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RegisterBalanceInfo } from './registerBalanceInfo';

export interface RegisterBalanceRequest {
  balanceInfos?: Array<RegisterBalanceInfo>;
}
